<h2>{{name}}</h2>
<hr/>
<h5>{{desc}}</h5>
<p>
  Emulates the old logic from $q.defer().<br>
  It creates (triggers) a native promise and wraps it into the generated object, exposing at the same
  time its resolve() and reject() functions. It also exposes the status of the promise.
</p>

<h5 class="mt-4">Members:</h5>
<div class="col-12"><pre>{{api}}</pre></div>

<hr>
<h5 class="marB20">Examples:</h5>

<div class="row">
  <div class="col-6 padT15">
    <div class="examples-table">
      <div class="code-box padV10 padH15">
        <pre style="font-size: 16px;">{{example1}}</pre>
      </div>
    </div>
  </div>

  <div class="col-6">
    <div class="row whiteBg">
      <div class="col-12"><h5 class="marB20">Running Example:</h5></div>
      <div class="col-3"><jb-input jbLabel="Resolve after" [(ngModel)]="resolveTime" [jbDisabled]="myDef?.status === 0"></jb-input></div>
      <div class="col-3"><jb-input jbLabel="Reject after" [(ngModel)]="rejectTime" [jbDisabled]="myDef?.status === 0"></jb-input></div>
      <div class="col-6 padT25 padH20">{{testLog}}</div>

      <div class="col-3">
        <jb-btn jbText="def.resolve()" jbType="save" class="full-width"
                [jbDisabled]="myDef?.status !== 0"
                (jbClick)="myDef.resolve('Manually')">
        </jb-btn>
      </div>
      <div class="col-3">
        <jb-btn jbText="def.reject()" jbType="warning" class="full-width"
                [jbDisabled]="myDef?.status !== 0"
                (jbClick)="myDef.reject('Manually')">
        </jb-btn>
      </div>


      <div class="col-6">
        <jb-btn jbText="def = new JbDefer()" class="full-width"
                [jbDisabled]="myDef?.status === 0"
                (jbClick)="initTest()">
        </jb-btn>
      </div>
    </div>
  </div>
</div>
